import React, { useState } from "react";
import axios from "axios";
import { Input, AlertCard, Button } from "@texada/ui";
import { isEmpty } from "lodash";
import { Link } from "react-router-dom";
import i18n from "i18n/i18n";
import {
  INTERNAL_SERVER_ERROR,
} from "http-status-codes";
import LoginInfoDisplay from "../LoginInfoDisplay";
import MainScreen from "../MainScreen";
import { getForgotPasswordUrl } from "helpers/urls";
import { USER_MIGRATE_STATUS, FORGET_PASSWORD_URL } from "constants/AppConstants";

const ForgotPassword = () => {
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [isLoading, setLoading] = useState(false);
  
  const resetPassword = async () => {
    setErrors({});
    setLoading(true);
    
    const serverError = {
      message: i18n.t("connection_error_please_try_again_later_or_contact_texada_software")
    };

    const res = await axios.post(USER_MIGRATE_STATUS, {
      email: email
    });
    const url = res.data.migrated ? FORGET_PASSWORD_URL : getForgotPasswordUrl();

    try {
      await axios.post(url, { email });
      setEmailSent(!emailSent);
    } catch (err) {
      const errors = {
        message:
          err.response.status === INTERNAL_SERVER_ERROR
            ? serverError.message
            : err.response.data.error
      };
      setErrorMsg(errors);
    }
    setLoading(false);
  };

  const onSubmit = e => {
    e.preventDefault();

    if (isEmpty(email)) {
      setErrors({ email: "Enter your email address" });
    } else {
      resetPassword();
    }
  };

  const textFields = emailSent ? (
    <>
      <AlertCard type="info" size="full" closable={false}>
        Please check your email for a link to reset your password. If this email
        is associated with a user account, it should appear in your inbox within
        a few minutes.
      </AlertCard>
      <Link className="login-link" to="/">
        Return to sign in
      </Link>
    </>
  ) : (
    <>
      <AlertCard type="info" size="full" closable={false}>
        Enter your email below and we will send you a link to reset your
        password:
      </AlertCard>

      <Input
        className="forgot-email"
        field="Email"
        value={email}
        error={errors.email}
        onChange={e => setEmail(e.target.value)}
        type="email"
        label="Email"
        required
        disabled={isLoading}
      />

      <Button
        className="login-button"
        isLoading={isLoading}
        buttonProps={{ type: "submit" }}
      >
        Reset Password
      </Button>
    </>
  );

  return (
    <MainScreen>
      <form className="login_form" onSubmit={onSubmit}>
        {errors.message && <LoginInfoDisplay error={errors.message} />}
        {textFields}
        {!emailSent && (
          <Link to="/" className="login-link">
            Return to sign in
          </Link>
        )}
      </form>
    </MainScreen>
  );
};
export default ForgotPassword;
